export default __webpack_public_path__ + "static/media/trimming.8bda3689.png";